<template>
  <div class="rightTableDiv">
<!--    :style="{'gridTemplateRows': `repeat(${Math.ceil(data.length / 7)}, calc(100% / ${Math.ceil(data.length / 7)}))`}"-->
    <div class="deptNumDiv">
      <span>
        未配置归口部门的公司：
      </span>
      <span>{{ pagination.total }}</span>
    </div>
    <a-spin :spinning="loading">
      <div class="deptNameDiv">
        <a-tooltip v-for="(item, index) in data" :key="index">
          <template slot="title">
            {{ item.subcompanyname }}
          </template>
          <span>{{ item.subcompanyname }}</span>
        </a-tooltip>
      </div>
    </a-spin>
    <a-pagination
      class="pagination"
      show-quick-jumper
      v-model="pagination.pageNum"
      :pageSize="pagination.pageSize"
      :total="pagination.total"
      @change="handleTableChange" />
  </div>
</template>
<script>

import { getDeptUnConfigured } from '@/api/centralizedDeptManagement'
import { getTableScroll } from '@/views/assetLedger/modules/height'

export default {
  name: 'TableData',
  components: {

  },
  computed: {

  },
  data () {
    return {
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 77,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      columns: [
        {
          title: '公司名称',
          dataIndex: 'subcompanyname'
        }
      ],
      data: [],
      scrollY: 0
    }
  },
  created () {
    this.getUnConfiguredData()
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollY = getTableScroll(90, 'centralizedDeptManagementTable', '')
    })
  },
  watch: {

  },
  methods: {
    // 获取未配置的数据
    getUnConfiguredData () {
      this.data = []
      const data = {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum,
        paging: true
      }
      this.loading = true
      getDeptUnConfigured(data).then(res => {
        if (res.status === 0) {
          res.data.list.forEach((item, index) => {
            item.key = index
          })
          this.data = res.data.list
          this.pagination.total = res.data.total
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
          this.loading = false
        })
    },

    handleTableChange (pageNum, pageSize) {
      this.pagination.pageNum = pageNum
      this.pagination.pageSize = pageSize
      this.getUnConfiguredData()
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.deptNumDiv {
  margin-bottom: 16px;
  span {
    font-size: 12px;
    font-weight: bold;
  }
  span:nth-child(1) {
    color: rgba(51, 51, 51, 1);
  }
  span:nth-child(2) {
    color: rgba(23, 145, 255, 1);
  }
}
.ant-spin-nested-loading {
  height: calc(100% - 66px);
  .ant-spin-container {
    height: 100%;
    .deptNameDiv {
      display: grid;
      grid-template-columns: repeat(7, calc((100% - 180px )/ 7));
      //grid-template-rows: repeat(12, calc(100% / 12));
      max-height: 100%;
      grid-column-gap: 30px;
      grid-row-gap: 16px;
      overflow-y: auto;
      span {
        height: 28px;
        line-height: 28px;
        text-align: center;
        background-color: rgba(245, 245, 245, 1);
        padding: 0 12px;
        border: 1px solid #DDDDDD;
        border-radius: 3px;
        // 超出显示省略号
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.pagination {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
